// import React, { useEffect, useState } from "react";
// import TemplateApi from "../../api/TemplateApi";
// import { showSuccess, showError } from "../../utils/toastUtils";

// function EditDetails({ data, refresh }) {
//   const [form, setForm] = useState({
//     templateName: "",
//     templateType: "",
//     url: "",
//     variantType: "",
//     description: "",
//   });

//   const [loading, setLoading] = useState(false);

//   /* ================= URL NORMALIZER ================= */
//   const normalizeUrl = (url) => {
//     if (!url.startsWith("http://") && !url.startsWith("https://")) {
//       return `https://${url}`;
//     }
//     return url;
//   };

//   /* ================= SET FORM ================= */
//   useEffect(() => {
//     if (data && typeof data === "object") {
//       setForm({
//         templateName: data.templateName || "",
//         templateType: data.templateType || "",
//         url: data.url || "",
//         variantType: data.variantType || "",
//         description: data.description || "",
//       });
//     }
//   }, [data]);

//   const handleChange = (e) => {
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
//   };

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !form.templateName ||
//       !form.templateType ||
//       !form.url ||
//       !form.variantType
//     ) {
//       return showError("All required fields must be filled");
//     }

//     const payload = {
//       id: data._id, // ✅ REQUIRED
//       ...form,
//       url: normalizeUrl(form.url), // ✅ FIX
//     };

//     try {
//       setLoading(true);
//       const res = await TemplateApi.update(payload);

//       if (res.code === 200) {
//         showSuccess(res.message);
//         refresh?.();
//         document
//           .querySelector("#edit-template-modal .btn-close")
//           ?.click();
//       } else {
//         showError(res.message);
//       }
//     } catch (err) {
//       console.error(err);
//       showError("Failed to update template");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!data) return null;

//   return (
//     <div className="modal fade" id="edit-template-modal" tabIndex={-1}>
//       <div className="modal-dialog modal-md">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5>Edit Template</h5>
//             <button className="btn-close" data-bs-dismiss="modal" />
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="modal-body">
//               {["templateName", "templateType", "url", "variantType"].map(
//                 (f) => (
//                   <div className="mb-3" key={f}>
//                     <label className="form-label">{f}</label>
//                     <input
//                       name={f}
//                       className="form-control"
//                       value={form[f]}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 )
//               )}

//               <div className="mb-3">
//                 <label className="form-label">Description</label>
//                 <textarea
//                   name="description"
//                   className="form-control"
//                   rows={3}
//                   value={form.description}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={loading}
//               >
//                 {loading ? "Updating..." : "Update"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EditDetails;


import React, { useEffect, useState } from "react";
import TemplateApi from "../../api/TemplateApi";
import { showSuccess, showError } from "../../utils/toastUtils";

function EditDetails({ data, refresh }) {
  const [form, setForm] = useState({ templateName: "", templateType: "", url: "", variantType: "", description: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data?._id) {
      setForm({
        templateName: data.templateName || "",
        templateType: data.templateType || "",
        url: data.url || "",
        variantType: data.variantType || "",
        description: data.description || "",
      });
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await TemplateApi.update({ id: data._id, ...form });
      if (res.code === 200) {
        showSuccess(res.message);
        refresh?.();
        document.querySelector("#edit-template-modal .btn-close")?.click();
      }
    } catch (err) {
      showError("Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="edit-template-modal" tabIndex={-1}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header"><h5>Edit Template</h5><button className="btn-close" data-bs-dismiss="modal" /></div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {["templateName", "templateType", "url", "variantType"].map((f) => (
                <div className="mb-3" key={f}>
                  <label className="form-label">{f}</label>
                  <input name={f} className="form-control" value={form[f]} onChange={(e) => setForm({...form, [f]: e.target.value})} />
                </div>
              ))}
              <div className="mb-3"><label>Description</label><textarea name="description" className="form-control" rows={3} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} /></div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Updating..." : "Update"}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditDetails;